var _circle, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignedWthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#C6DDFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    width: 14,
    height: 11,
    fill: "#1A2CCE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 36V33.325L31.2 29.625L33.875 32.3L30.175 36H27.5ZM34.575 31.6L31.9 28.925L33.425 27.4C33.575 27.25 33.75 27.175 33.95 27.175C34.15 27.175 34.325 27.25 34.475 27.4L36.1 29.025C36.25 29.175 36.325 29.35 36.325 29.55C36.325 29.75 36.25 29.925 36.1 30.075L34.575 31.6ZM22 22V20.5H31V22H22ZM22 25V23.5H31V25H22ZM18.625 36C17.8917 36 17.2708 35.7458 16.7625 35.2375C16.2542 34.7292 16 34.1083 16 33.375V30H19V16H34V25.65C33.7333 25.65 33.475 25.7 33.225 25.8C32.975 25.9 32.7333 26.0417 32.5 26.225V17.5H20.5V30H28.7L26 32.7V36H18.625Z",
    fill: "#1A2CCE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 28,
    width: 2,
    height: 2,
    fill: "#C6DDFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 28,
    width: 15,
    height: 1,
    fill: "#1A2CCE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20.5,
    width: 9,
    height: 1.5,
    fill: "#C6DDFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 23.5,
    width: 9,
    height: 1.5,
    fill: "#C6DDFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 9,
    height: 1.5,
    fill: "#C6DDFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedWthIcon);
export default __webpack_public_path__ + "static/media/signed_wth_icon.fc4be62d241e455252f53187dd15be35.svg";
export { ForwardRef as ReactComponent };